// src/components/resources/layouts/ClientTemplatesLayout.tsx

'use client'

import { motion } from 'motion/react'
import useScroll from '~/lib/use-scroll'
import { Breadcrumbs } from '~/components/resources/Breadcrumbs'
import type { ReactNode } from 'react'

interface ClientTemplatesLayoutProps {
  children: ReactNode
}

export function ClientTemplatesLayout({ children }: ClientTemplatesLayoutProps): JSX.Element {
  const scrolled = useScroll(50)

  return (
    <div className="min-h-screen bg-transparent">
      {/* Fixed top navigation bar */}
      <div className="fixed top-0 left-0 right-0 z-40">
        {/* Background gradient */}
        <div 
          className={`absolute inset-0 pointer-events-none transition-all duration-300 ease-in-out ${
            scrolled
              ? 'bg-gradient-to-b from-white via-white to-white/95 dark:from-gray-950 dark:via-gray-950 dark:to-gray-950/95'
              : 'bg-gradient-to-b from-white/60 via-white/30 to-transparent dark:from-gray-950/60 dark:via-gray-950/30 dark:to-transparent'
          }`} 
        />

        {/* Space for Navbar */}
        <div className="h-[80px]" />
        
        {/* Breadcrumbs */}
        <div className="relative">
          <Breadcrumbs />
        </div>
      </div>

      {/* Main Content */}
      <div className="pt-[142px]">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  )
} 